import { render, staticRenderFns, recyclableRender, components } from "./u-toolbar.vue?vue&type=template&id=6d25fc6f&scoped=true&"
var renderjs
import script from "./u-toolbar.vue?vue&type=script&lang=js&"
export * from "./u-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./u-toolbar.vue?vue&type=style&index=0&id=6d25fc6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25fc6f",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-toolbar/u-toolbar.vue"
export default component.exports